export const department = [
     {
        id: 1,
        name: "1st Year Department",
        subjects: [
            "Engineering Mathematics 1",
            "Physics 1",
            "Chemistry 1",
            "Engineering Mechanics",
            "Basic Electrical Engineering",
            "Language",
            "Engineering Mathematics 2",
            "Physics 2",
            "Chemistry 2",
            "Basic Electronics",
            "Disaster Management",
            "Introduction to Programming",
            "Previous Year Paper",
        ]
    },
    {
        id: 2,
        name: "Biomedical Engineering Department",
        subjects: [
            "Biomedical Instrumentation",
            "Medical Imaging",
            "Biomechanics",
            "Biomaterials",
            "Clinical Engineering",
            "Previous Year Paper"
        ]
    },
    {
        id: 3,
        name: "Chemical Engineering Department",
        subjects: [
            "Chemical Reaction Engineering",
            "Process Control",
            "Transport Phenomena",
            "Thermodynamics",
            "Separation Processes",
            "Previous Year Paper"
        ]
    },
    {
        id: 4,
        name: "Electronics and Instrumentation Department",
        subjects: [
            "Digital Signal Processing",
            "Artificial Intelligence and Expert",
            "Optoelectronic Instrumentation",
            "Industrial Process Control and Automation",
            "Analog Electronics and Linear Integrated Circuits",
            "Electrical Measurement and Measuring Instruments",
            "Sensors and Transducers",
            "Electronic Instrumentation",
            "Linear Control System",
            "Microprocessor and Microcontroller",
            "Industrial Instrumentation",
            "Data Communication and Networking",
            "Industrial Electronics",
            "Communication Theory and Telemetry",
            "Data Structures and Algorithms",
            "Digital Electronics",
            "Electro Magnetic Theory",
            "Biomedical Instrumentation",
            "Advanced Instrumentation",
            "Embedded Systems",
            "Numerical Methods and Linear Algebra",
            "Engineering Economics and Costing",
            "Industrial Management",
            "Advanced Microprocessor and Microcontroller",
            "Solid State Devices",
            "Digital Image Processing",
            "VLSI Design",
            "Laser and Non-Linear Optics",
            "Mobile Communication",
            "Advanced Optoelectronics and Photonics ",
            "Mathematics III (M-301)",
            "Network Theory",
            "Signals and Systems",
            "Object Oriented Programming",
            "Previous Year Paper"
        ]
    },
    {
        id: 5,
        name: "Electrical Engineering Department",
        subjects: [
            "Electric Circuits",
            "Power Electronics",
            "Electromagnetic Fields",
            "Power Systems",
            "Control Systems",
            "Engineering Mathematics III",
            "Electrical Measurement and Measuring Instruments",
            "Network Analysis",
            "Digital Electronics",
            "Object Oriented Programming",
            "Signals & Systems",
            "Seminar (Soft Skill Based)",
            "Electrical Machine-I",
            "Power System I",
            "Data Structures & Algorithms",
            "Numerical Methods and Analysis",
            "Analog Electronics",
            "Elective-I",
            "Electrical Machine-II",
            "Power Electronics",
            "Microprocessors and Microcontroller",
            "Control System-I",
            "Electromagnetic Field Theory",
            "Seminar",
            "Power System II",
            "Digital Signal Processing",
            "Industrial Instrumentation",
            "Principle of Communication",
            "Electrical Drives",
            "Engineering Economics",
            "Elective II",
            "Elective III",
            "Previous Year Paper"
        ]
    },
    {
        id: 6,
        name: "Electronics and Communication Engineering Department",
        subjects: [
            "Analog Electronics",
            "Digital Signal Processing",
            "Microprocessors",
            "Communication Systems",
            "VLSI Design",
            "Mathematics III",
            "Data Structures and Algorithms",
            "Semiconductor Devices",
            "Analog Electronic Circuits-I",
            "Network Analysis and Synthesis",
            "Signals & Systems",
            "Engineering Economics & Accounts",
            "Analog Electronic Circuits-II",
            "Electromagnetic Theory & Antennas",
            "Probability and Random Processes",
            "Digital Electronics",
            "Control Systems",
            "Industrial Management",
            "Analog and Digital Communication",
            "Electronic Instrumentation & Measurement",
            "Microwave Engineering",
            "Optical Fibre Communication",
            "VLSI Technology",
            "Information Theory & Coding",
            "Data Communication Network",
            "Wireless Communication",
            "Elective-I (Departmental)",
            "Elective-II (Departmental/Open)",
            "Project Preliminary",
            "Industrial Training and Seminar",
            "Previous Year Paper"
        ]
    },
    {
        id: 7,
        name: "Computer Science and Engineering Department",
        subjects: [
            "Data Structures",
            "Algorithms",
            "Operating Systems",
            "Database Systems",
            "Computer Networks",
            "Previous Year Paper"
        ]
    },
    {
        id: 8,
        name: "Civil Engineering Department",
        subjects: [
            "Structural Analysis",
            "Geotechnical Engineering",
            "Transportation Engineering",
            "Water Resources Engineering",
            "Construction Management",
            "Mechanics of Solids",
            "Engineering Geology",
            "Mechanics of Fluids",
            "Value Education, Ethics, and Environmental Studies",
            "Mathematics - III",
            "Humanities - III",
            "Design of Structures",
            "Building Materials",
            "Construction and Services",
            "Surveying",
            "Structural Analysis - II",
            "Design of Structures - II",
            "Water Resources Engineering - I",
            "Geotechnical Engineering - I",
            "Transportation Engineering - I",
            "Environmental Engineering - I",
            "Civil Engineering Estimation, Costing, and Specification",
            "Design of Structures - III",
            "Water Resources Engineering - II",
            "Geotechnical Engineering - II",
            "Transportation Engineering - II",
            "Environmental Engineering - II",
            "Construction Planning and Management",
            "Data Structures and Numerical Methods",
            "H.S.S Elective",
            "Previous Year Paper"
        ]
    },
    {
        id: 9,
        name: "Mechanical Engineering Department",
        subjects: [
            "Thermodynamics",
            "Fluid Mechanics",
            "Machine Design",
            "Heat Transfer",
            "Manufacturing Processes",
            "Previous Year Paper",
            "Basic Engineering Thermodynamics",
            "Engineering Materials",
            "Fluid Mechanics-I",
            "Mathematics-III",
            "Applied Electrical and Electronics Engineering",
            "Strength of Materials",
            "Applied Thermodynamics",
            "Kinematics of Machine",
            "Fluid Mechanics-II",
            "Manufacturing Technology-I",
            "Numerical Methods & Computer Programming",
            "Design of Machine Elements-I",
            "Heat & Mass Transfer",
            "Design of Machine Elements-II",
            "Manufacturing Technology-II",
            "Fluid Machinery",
            "Vibration and Control",
            "Mechanical Measurement & Instrumentation",
            "Dynamics of Machines",
            "Advanced Manufacturing Processes",
            "Refrigeration & Air Conditioning",
            "I.C. Engines",
            "Thermal Power Engineering",
            "Industrial Engineering & Management",
            "Environmental Engineering (Mandatory Course)",
            "Elective-I (Power Plant Engineering)",
            "Elective-I (Industrial Tribology)",
            "Elective-II (Automobile Engineering)",
            "Elective-II (Product Design for Manufacturability and Assembly)",
            "Mechanical System Design & Industrial Automation",
            "Entrepreneurship Development",
            "Elective-III (Computational Fluid Dynamics)",
            "Elective-III (Additive Manufacturing)",
            "Elective-IV (Powder Metallurgy)",
            "Elective-IV (CAD and Geometric Modeling)",
            "Elective-V (Advanced Machine Design)",
            "Elective-V (Boundary Layer Theory)",
            "Previous Year Paper"
        ]
    },
    {
        id: 10,
        name: "Production Engineering Department",
        subjects: [
            "Manufacturing Processes",
            "Operations Management",
            "Quality Control",
            "Industrial Automation",
            "Tool Design",
            "Engineering Thermodynamics",
            "Solid Mechanics",
            "Fluid Mechanics",
            "Manufacturing Processes I",
            "Electrical Machines",
            "Solid Mechanics Laboratory",
            "Thermal Power Engineering",
            "Numerical Methods for Computing",
            "Plant Layout & Material Handling",
            "Measurement and Instrumentation",
            "Mechanics of Machines",
            "Engineering Materials",
            "Thermal Power Engineering Laboratory",
            "Design of Machine Elements",
            "Ergonomics and Work System Design",
            "Production Planning and Control",
            "Computer Aided Design and Manufacturing",
            "Manufacturing Processes II",
            "Machine Tool System",
            "Operations Research",
            "Automation, CNC and Robotics",
            "Reliability Engineering and Plant Maintenance",
            "Non-Traditional Manufacturing",
            "Production and Quality Management",
            "Financial Management and Costing",
            "Previous Year Paper"
        ]
    },
    {
        id: 11,
        name: "Industrial Engineering Department",
        subjects: [
            "Operations Research",
            "Production Planning",
            "Quality Control",
            "Supply Chain Management",
            "Ergonomics",
            "Previous Year Paper"
        ]
    },
    {
        id: 12,
        name: "Mathematics Department",
        subjects: [
            "Calculus",
            "Linear Algebra",
            "Probability and Statistics",
            "Differential Equations",
            "Numerical Methods",
            "Previous Year Paper"
        ]
    },
    {
        id: 13,
        name: "Physics Department",
        subjects: [
            "Classical Mechanics",
            "Electromagnetism",
            "Quantum Mechanics",
            "Statistical Physics",
            "Optics",
            "Previous Year Paper"
        ]
    },
    {
        id: 14,
        name: "Management and Humanities and Social Science Department",
        subjects: [
            "Management Principles",
            "Organizational Behavior",
            "Human Resource Management",
            "Ethics",
            "Social Sciences",
            "Previous Year Paper"
        ]
    },
    {
        id: 15,
        name: "Chemistry Department",
        subjects: [
            "Organic Chemistry",
            "Inorganic Chemistry",
            "Physical Chemistry",
            "Analytical Chemistry",
            "Biochemistry",
            "Previous Year Paper"
        ]
    },
   
];
